import { ajaxStatusActions } from './AjaxStatusActions';
import { IEvent } from '../../Interfaces/IEvent';

const initAjaxCallInProgressCount = 0;

const ajaxStatusReducer = (
  state: number = initAjaxCallInProgressCount,
  action: IEvent
): number => {
  switch (action.type) {
    case ajaxStatusActions.BEGIN_AJAX_CALL:
      return state + 1;

    case ajaxStatusActions.END_AJAX_CALL:
      return state - 1;

    default:
      return state;
  }
};

export default ajaxStatusReducer;
